/*
  Open Goaaal product pages (og-pdp-*): gallery arrows and thumbnail strip for
  the native rebuild of the former GemPages product pages, 16.10.2026.
  Slide selection, thumbnails and add to cart are handled by og-home.js and
  the theme's <product-form>; this file only adds the arrows and keeps the
  active thumbnail in view.
*/
(() => {
  function initGallery(gallery) {
    if (gallery.dataset.ogPdpReady) return;
    gallery.dataset.ogPdpReady = 'true';
    const track = gallery.querySelector('.og-gallery__track');
    const strip = gallery.querySelector('[data-og-gallery-thumbs]');
    if (!track) return;
    const slides = Array.from(track.children);

    const currentIndex = () => (track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0);
    const goTo = (index) => {
      const target = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    };

    const prev = gallery.querySelector('[data-og-gallery-prev]');
    const next = gallery.querySelector('[data-og-gallery-next]');
    if (prev) prev.addEventListener('click', () => goTo(currentIndex() - 1));
    if (next) next.addEventListener('click', () => goTo(currentIndex() + 1));

    const updateArrows = () => {
      const index = currentIndex();
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= slides.length - 1;
    };

    /* Keep the active thumbnail inside the strip without scrolling the page. */
    const revealThumb = () => {
      if (!strip) return;
      const active = strip.querySelector('.og-gallery__thumb.is-active');
      if (!active) return;
      const left = active.offsetLeft - strip.offsetLeft;
      const right = left + active.offsetWidth;
      if (left < strip.scrollLeft) {
        strip.scrollTo({ left, behavior: 'smooth' });
      } else if (right > strip.scrollLeft + strip.clientWidth) {
        strip.scrollTo({ left: right - strip.clientWidth, behavior: 'smooth' });
      }
    };

    let frame = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { updateArrows(); revealThumb(); });
    }, { passive: true });
    updateArrows();
  }

  function init(root = document) {
    root.querySelectorAll('[data-og-pdp-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
